// frontend_app/src/hooks/useModalManager.js
import { useState, useCallback } from 'react';

export const useModalManager = () => {
    // This state is now managed inside the hook, not in App.js
    const [modalData, setModalData] = useState(null);

    const openModal = useCallback((data) => {
        setModalData(data);
    }, []);

    const closeModal = useCallback(() => {
        setModalData(null);
    }, []);

    return {
        isModalOpen: !!modalData, // A handy boolean to know if the modal should be shown
        modalData,               // The data to display (the full result object)
        openModal,               // The function to open the modal
        closeModal,              // The function to close the modal
    };
};